import gql from 'graphql-tag';

const GET_AUDIENCE_DEVICES_S3 = gql`
  query getAudienceDevicesFromS3($audienceId: String!, $type: String!) {
    getAudienceDevicesFromS3(audienceId: $audienceId, type: $type)
  }
`;

export default GET_AUDIENCE_DEVICES_S3;
